import type { GoodId } from "../core/types";

export type Selection =
  | { kind: "node"; id: number }
  | { kind: "route"; id: number }
  | null;

export interface FloatText {
  x: number;
  y: number;
  text: string;
  color: string;
  life: number;
}

export const FLOAT_LIFETIME = 1.6;

export interface UiState {
  selection: Selection;
  /** Knoten-ID, von der aus gerade eine Strecke gezogen wird. */
  linkFrom: number | null;
  /** Good the pending link will carry, or null to derive it from the producer. */
  linkGood: GoodId | null;
  /**
   * The target picked while linking, when the network offers a cheaper path
   * through a waypoint and the player still has to choose (RFC-0033 PR 3).
   * Null means there was nothing to choose and the road was built straight away.
   */
  linkTo: number | null;
  hover: number | null;
  mouse: { x: number; y: number };
  /** 0 = pausiert. Sonst Simulationsschritte pro Frame. */
  speed: number;
  floats: FloatText[];
}

export function createUiState(): UiState {
  return {
    selection: null,
    linkFrom: null,
    linkGood: null,
    linkTo: null,
    hover: null,
    mouse: { x: 0, y: 0 },
    speed: 1,
    floats: [],
  };
}

export function selectionKey(s: Selection): string {
  return s ? `${s.kind}:${s.id}` : "none";
}
